import { Component } from '@angular/core';

import { FinancingFormCalculatorComponent } from '@organisms/financing-form/financing-form-calculator/financing-form-calculator.component';

@Component({
  selector: 'financing-form-calculator-page',
  imports: [FinancingFormCalculatorComponent],
  templateUrl: './financing-form-calculator.component.html',
})
export class FinancingFormCalculatorPageComponent {}
